import { render, staticRenderFns } from "./GymRoutesFilterBtn.vue?vue&type=template&id=1b4c923e"
import script from "./GymRoutesFilterBtn.vue?vue&type=script&lang=js"
export * from "./GymRoutesFilterBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports